import { render, staticRenderFns } from "./FileItemsModal.vue?vue&type=template&id=5b86a880&"
import script from "./FileItemsModal.vue?vue&type=script&lang=ts&"
export * from "./FileItemsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports